import { Capacitor } from "@capacitor/core";

// Reports which app build + platform a user is running so super-admin can see
// who is on the latest release and what device type they use.

let _version = null;

export function initClientVersion() {
  // version.json is stamped at build time (scripts/gen-version.js) and bundled
  // into the native apps, so this resolves to the running build on web and app.
  fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" })
    .then((r) => (r.ok ? r.json() : null))
    .then((v) => { if (v?.version) _version = v.version; })
    .catch(() => {});
}

export function clientVersion() {
  return _version || "";
}

export function clientPlatform() {
  try {
    if (Capacitor.isNativePlatform()) return Capacitor.getPlatform(); // "android" | "ios"
  } catch { /* not native */ }
  try {
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches
      || window.navigator?.standalone === true;
    return standalone ? "pwa" : "web";
  } catch {
    return "web";
  }
}
